
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/synthetic-data-generation",
      function () {
        return require("private-next-pages/services/synthetic-data-generation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/synthetic-data-generation"])
      });
    }
  